import React from "react";
import { Alert, Spin } from "antd";
import styles from "./OperationRequestWorkspace.module.css";
import OperationRequestOrderBriefCard from "./OperationRequestOrderBriefCard.jsx";
import OperationRequestPassengersCard from "./OperationRequestPassengersCard.jsx";
import OperationRequestFinancialCard from "./OperationRequestFinancialCard.jsx";
import OperationRequestPaymentsCard from "./OperationRequestPaymentsCard.jsx";
import OperationRequestSupplierCard from "./OperationRequestSupplierCard.jsx";
import OperationRequestAdminMetaCard from "./OperationRequestAdminMetaCard.jsx";

/**
 * @param {{
 *   context: Record<string, unknown>|null,
 *   loading?: boolean,
 * }} props
 */
export default function OperationRequestSidebar({ context, loading = false }) {
  if (!context) return null;
  const { orderSummary, passengers, financials, payments, supplierInfo, warnings } = context;

  return (
    <Spin spinning={Boolean(loading)} tip="טוען פירוט מהשרת…">
      <div className={styles.sidebarStack}>
        {warnings?.length ? (
          <Alert type="info" showIcon message={warnings.join(" ")} />
        ) : null}
        <OperationRequestOrderBriefCard orderSummary={orderSummary} />
        <OperationRequestPassengersCard passengers={passengers} />
        <OperationRequestFinancialCard financials={financials} />
        <OperationRequestPaymentsCard payments={payments} />
        <OperationRequestSupplierCard supplierInfo={supplierInfo} orderSummary={orderSummary} />
        <OperationRequestAdminMetaCard supplierInfo={supplierInfo} />
      </div>
    </Spin>
  );
}
